import generalUpload from "../_section/upload.class";

export class userBookingDepositReceiptUpload extends generalUpload {
    constructor(request, upload, queries) {
        super(request, upload, queries);
    }
}

const template = {
    items: [{
        name: 'documentDate',
        label: 'Document Date',
        type: 'date',
    },
        {
            name: 'amount',
            label: 'Deposit Amount',
            type: 'currency',
        }]
}

export class adminBookingDepositReceiptUpload extends userBookingDepositReceiptUpload {

    constructor(request, upload, queries) {
        super(request, upload, queries);
        this.calcValues(template)
        if (this.values.expiryDate) {
            this.setDateData({
                dated: this.values.documentDate,
                expires: this.values.documentDate().add(1, 'year'),
            })
        }
    }


}
